import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeFirstLetter } from "../../utils/utils";
import { logoutUser } from "../../commonfunctions";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../languageSwitcher";
import "./index.css";

function TopbarAvatar({ src, initials, palette, onClick }) {
  const { t } = useTranslation("components");
  var state = useState(false);
  var imgError = state[0];
  var setImgError = state[1];
  if (src && !imgError) {
    return (
      <img
        onClick={onClick}
        className="mini-photo pointer"
        src={src}
        width="36"
        height="36"
        alt={t("avatar.profileAlt")}
        style={{ borderRadius: '50%', objectFit: 'cover' }}
        onError={function() { setImgError(true); }}
      />
    );
  }
  return (
    <div
      onClick={onClick}
      className="mini-photo pointer"
      style={{
        width: 36, height: 36, borderRadius: '50%',
        background: palette.background, color: palette.color,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontWeight: '700', fontSize: '13px', flexShrink: 0, userSelect: 'none',
      }}
    >
      {initials}
    </div>
  );
}

const Topbar = () => {
  const { t } = useTranslation();
  const auth = useSelector((state) => state.user);
  const role = useSelector((state) => state.auth);
  const {
    renderTypeInfo,
    bookingTypeInfo,
  } = useSelector((state) => state.client);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const logout = () => {
    logoutUser(dispatch, navigate);

    // localStorage.clear()
    // window.location.reload();
  };
  const [open, setOpen] = useState(false);
  const [iconSize, setIconSize] = useState(25);
  
     useEffect(() => {
      const updateSize = () => {
        if (window.innerWidth <= 768) {
          setIconSize(20); // Mobile
        } else {
          setIconSize(25); // Tablet/Desktop
        }
      };
  
      updateSize(); // run once on mount
      window.addEventListener("resize", updateSize);
      return () => window.removeEventListener("resize", updateSize);
    }, []);
  return (
    <div className="headar-saction site-topbar">
      <div className="container">
        <div className="site-topbar-row d-flex align-items-center justify-content-between" style={{ gap: '8px' }}>
          <div className="site-topbar-logo">
            <div className="logo-saction">
              <a href="javascript:void(0)">
                <img src="../images/logo-verysoul.png" alt="LOGO" />
              </a>
            </div>
          </div>
          <div className="site-topbar-icons" style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            {role.role != "admin"  &&
            <div className="iconEl" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
              
              <a href="https://facebook.com/profile.php?id=100091181185849" target="_blank" rel="noopener noreferrer" className="mr-1">
                <svg
                  aria-hidden="true"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  width={iconSize}
                  height={iconSize}
                  fill="black"
                >
                  <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"/>
                </svg>
              </a>
              <a href="https://instagram.com/verysoulapp" target="_blank" rel="noopener noreferrer" className="mr-1">
                <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
           width={iconSize}
                  height={iconSize}
            fill="black" // Instagram pink (optional)
          >
            <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
          </svg>
              </a>
              <a href="https://tiktok.com/@verysoulapp" target="_blank" rel="noopener noreferrer">
                <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="black"
            viewBox="0 0 449.45 515.38"
            width={iconSize}
                  height={iconSize}
          >
            <path
              fillRule="nonzero"
              d="M382.31 103.3c-27.76-18.1-47.79-47.07-54.04-80.82-1.35-7.29-2.1-14.8-2.1-22.48h-88.6l-.15 355.09c-1.48 39.77-34.21 71.68-74.33 71.68-12.47 0-24.21-3.11-34.55-8.56-23.71-12.47-39.94-37.32-39.94-65.91 0-41.07 33.42-74.49 74.48-74.49 7.67 0 15.02 1.27 21.97 3.44V190.8c-7.2-.99-14.51-1.59-21.97-1.59C73.16 189.21 0 262.36 0 352.3c0 55.17 27.56 104 69.63 133.52 26.48 18.61 58.71 29.56 93.46 29.56 89.93 0 163.08-73.16 163.08-163.08V172.23c34.75 24.94 77.33 39.64 123.28 39.64v-88.61c-24.75 0-47.8-7.35-67.14-19.96z"
            />
          </svg>
              </a>
            </div>
            }
          </div>
          <div className="site-topbar-user" style={{ minWidth: 0, flexShrink: 1, display: "flex", alignItems: "center", gap: "10px" }}>
            {(role.role === "client" || role.role === "medium") && <LanguageSwitcher />}

            {window.location.pathname !== "/terms-conditions" &&
              window.location.pathname !== "/privacy-policy" &&
              window.location.pathname !== "/payment-cancelled" &&
              window.location.pathname !== "/thank-you-page" &&
              window.location.pathname !== "/check-in-service" &&
              window.location.pathname !== `/paymymedium/${params.id}` && window.location.pathname !== `/guest-booking/${params.id}`  && window.location.pathname !== `/interview-booking/${params.id}` &&
              window.location.pathname !== '/registration' &&
              (
                <div className="user-saction">
                  {window.location.pathname === `/appointment` && <>
                    {renderTypeInfo === "startBookaSessionLaterQuestions" && bookingTypeInfo === "outreach" && <Link to='/intro-video' >{t("topbar.introVideo")}</Link>}
                    {renderTypeInfo === "book-specific-professinal" && bookingTypeInfo === "professional" && <Link to='/intro-video'  >{t("topbar.introVideo")}</Link>}
                  </>}
                  
                  <div className="user-menu-wrap">
                    
                    <div

                      className="mini-photo-wrapper "
                    >
                      {(() => {
                        const name = auth.user.screen_name || ((auth.user.first_name || '') + ' ' + (auth.user.last_name || '')).trim();
                        const parts = name.trim().split(' ').filter(Boolean);
                        const initials = parts.length >= 2
                          ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
                          : name.substring(0, 2).toUpperCase();
                        const palettes = [
                          { background: '#d5a67b', color: '#fff' },
                          { background: '#b86010', color: '#fff' },
                          { background: '#1a7a45', color: '#fff' },
                          { background: '#7722aa', color: '#fff' },
                          { background: '#cc2222', color: '#fff' },
                        ];
                        const palette = palettes[(name.charCodeAt(0) || 0) % palettes.length];
                        const profileImage = auth.user.profile_image;
                        const src = profileImage ? (process.env.REACT_APP_IMAGE_URL + profileImage) : null;
                        return <TopbarAvatar src={src} initials={initials} palette={palette} onClick={function() { setOpen(!open); }} />;
                      })()}
                      <span className="pointer" onClick={() => setOpen(!open)}>{auth.user.screen_name
                        ? capitalizeFirstLetter(auth.user.screen_name)
                        : capitalizeFirstLetter(auth.user.first_name)}
                      </span>
                      <img
                        onClick={() => setOpen(!open)}
                        src="../images/dropdown.png"
                        className="dropdowan pointer"
                        alt="dropdown.png"
                      />
                    </div>
                    {open && (
                      <div className="menu-container">
                        <ul className="user-menu">
                          {/* <li className="user-menu__item">
                        <a className="user-menu-link" href="#">
                          Achievements
                        </a>
                      </li>
                      <li className="user-menu__item">
                        <a className="user-menu-link" href="#">
                          Team
                        </a>
                      </li>
                      <li className="user-menu__item">
                        <a className="user-menu-link" href="#">
                          Log History
                        </a>
                      </li> */}
                       <li className="user-menu__item">
                          <a
                            className="user-menu-link"
                            href="https://support.verysoul.com/portal/en/newticket"
                            target="_blank"
                          // data-target="#logoutModal"
                          // data-toggle="modal"

                          >
                            {t("topbar.helpSupport")}
                          </a>
                          </li>
                          <li onClick={logout} className="user-menu__item">
                            <a
                              className="user-menu-link"
                              href="javascript:void(0);"
                              style={{ color: "#F44336" }}
                            >
                              {t("topbar.logout")}
                            </a>
                          </li>
                          {/* <li className="user-menu__item">
                        <a className="user-menu-link" href="#">
                          Settings
                        </a>
                      </li> */}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Topbar;
